import React, { useState, useEffect } from "react";
import axios from "axios";

const GradeRow = ({ grade, gradeColumn }) => (
    <tr>
        <td>{gradeColumn.name}</td>
        <td>{grade.score}</td>
        <td>{grade.status}</td>
    </tr>
);

const ReportCard = ({ platformUrl }) => {
    const [grades, setGrades] = useState([]);
    const [gradeColumns, setGradeColumns] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        const uuid = params.get("uuid");
        const courseUuid = params.get("courseUuid");

        if (!token || !uuid || !courseUuid) {
            setError("Missing access token, UUID, or course UUID. Please log in.");
            setLoading(false);
            return;
        }

        const fetchGrades = async () => {
            try {
                // Step 1: Get the user ID using the UUID
                const userResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v1/users/uuid:${uuid}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const userId = userResponse.data.id;

                // Step 2: Get the course ID using the course UUID
                const courseResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v1/courses/uuid:${courseUuid}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const courseId = courseResponse.data.id;

                // Step 3: Fetch grades for the user in the specified course
                const gradesResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v1/courses/${courseId}/gradebook/users/${userId}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                const gradesData = gradesResponse.data.results;
                setGrades(gradesData);

                // Step 4: Fetch grade column details for each grade column
                const columnPromises = gradesData.map(async (grade) => {
                    const columnResponse = await axios.get(
                        `${platformUrl}/learn/api/public/v1/courses/${courseId}/gradebook/columns/${grade.columnId}`,
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );
                    return { [grade.columnId]: columnResponse.data };
                });

                const columnsData = await Promise.all(columnPromises);
                const columnsMap = columnsData.reduce((acc, column) => ({ ...acc, ...column }), {});
                setGradeColumns(columnsMap);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGrades();
    }, []);

    if (loading) {
        return <div className="bb-loading">Loading...</div>;
    }

    if (error) {
        return (
            <div className="bb-error">
                <h1>Error</h1>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="report-card-container">
            <h1>Report Card</h1>
            {grades.length === 0 ? (
                <p>No grades available for this course.</p>
            ) : (
                <table className="bb-table">
                    <thead>
                        <tr>
                            <th>Grade Column</th>
                            <th>Score</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {grades.map((grade) => (
                            <GradeRow key={grade.columnId} grade={grade} gradeColumn={gradeColumns[grade.columnId]} />
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ReportCard;
